// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.white,
    display: 'flex',
    alignItems: 'flex-end',
    padding: theme.other.spacing._8,
    width: '100%',
    boxSizing: 'border-box',
    borderBottomLeftRadius: theme.radius.sm,
    borderBottomRightRadius: theme.radius.sm,
  },

  buttonContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.other.spacing._8,
    padding: theme.other.spacing._8,
    paddingTop: theme.other.spacing._8,
    paddingBottom: theme.other.spacing._8,
    flexShrink: 0,
    boxSizing: 'border-box',
  },

  addMediaButton: {
    backgroundColor: theme.colors.gray2[6], // #1a1c1e
    border: 'none',
    borderRadius: theme.other.spacing._24,
    padding: theme.other.spacing._4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    flexShrink: 0,

    '&:hover': {
      backgroundColor: theme.colors.gray2[5],
    },

    '&:focus': {
      outline: `2px solid ${theme.colors.blue[5]}`,
      outlineOffset: 2,
    },

    '&:disabled': {
      backgroundColor: theme.colors.gray2[2],
      cursor: 'not-allowed',
    },
  },

  addMediaIcon: {
    width: theme.other.spacing._16,
    height: theme.other.spacing._16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  inputWrapper: {
    position: 'relative',
    flex: 1,
    marginLeft: theme.other.spacing._8,
    marginRight: theme.other.spacing._8,
    marginBottom: theme.other.spacing._4,
  },

  inputField: {
    backgroundColor: theme.white,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
    border: `0.5px solid ${theme.colors.gray2[2]}`,
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.other.spacing._16,
    paddingLeft: theme.other.spacing._16,
    paddingRight: theme.other.spacing._16,
    paddingTop: theme.other.spacing._8,
    paddingBottom: theme.other.spacing._8,
    boxSizing: 'border-box',
  },

  input: {
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 20,
    color: theme.colors.gray2[6], // #1a1c1e
    flex: 1,
    height: 20,
    width: 296,
    paddingLeft: 0,

    '&::placeholder': {
      color: theme.colors.gray2[3], // #909296
      fontWeight: 500,
    },

    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  },
  createPostButton: {
    width: '100%',
    maxWidth: '100%',
    padding: 0,
    margin: 0,
  },

  sendButton: {
    width: '20px !important',
    height: '20px !important',
    minWidth: 20,
    minHeight: 20,
    borderRadius: theme.other.spacing._16,
    backgroundColor: theme.colors.gray2[6],

    '&:hover': {
      backgroundColor: `${theme.colors.gray2[5]} !important`,
    },
  },

  postButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    padding: theme.other.spacing._8,
    boxSizing: 'border-box',
    borderBottomLeftRadius: theme.radius.sm,
    borderBottomRightRadius: theme.radius.sm,
    backgroundColor: theme.white,
  },

  characterCounter: {
    minWidth: 20,
    textAlign: 'center',
    opacity: 0,
    height: 0,
    overflow: 'hidden',
    transition: 'opacity 150ms ease-in-out, height 150ms ease-in-out',
  },

  characterCounterVisible: {
    opacity: 1,
    height: 'auto',
  },
}));

export default useStyles;
